import Inter_SemiBold_woff2_namespaceObject from "../../static/font/Inter-SemiBold.woff2";
export default Inter_SemiBold_woff2_namespaceObject;
